<template>
  <div class="cashflow-table mini-periodicals-table">
    <DataTable
      name="financial.cashflow"
      :items="filtered"
      :tablehdrs="tableheaders.financial.overview_periodicals[type - 1]"
      :itemsperpage="5"
      :paginationOptions="[ 5 ]"
      hidefooter
    >
      <template v-slot:default="{ item }">
        <tr
          class="table-row periodicals-row mini-periodicals-row"
          @click.stop="$router.push({ name: 'financial:page:view', params: { page: 'fluxo', id: item.id }})"
        >
          <td class="date-col">
            <span :class="`${item.due.color}--text`">
              {{ item.due.text }}
            </span>
          </td>
          <td v-if="type === 2">
            <Employee :value="item.ref" />
          </td>
          <td class="title-col">
            <span>{{ item.title }}</span>
          </td>
          <td>
            <span class="text-body-1 font-weight-black">{{ formatCurrency(item.value) }}</span>
          </td>
          <td class="actions-col">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="$router.push({ name: 'financial:page:view', params: { page: 'fluxo', id: item.id }})"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.financial.cashflow.actions.view }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Employee from '@/components/users/templates/Employee'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import periodicals from '@/components/financial/periodicals/mixins/index'

import moment from 'moment'

export default {
  components: { DataTable, Employee },
  mixins: [ appdata, utils, periodicals ],
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    filtered () {
      let data = (((this.get_data || {}).financial || {}).periodicals || [])
            .filter(per => {
              return (this.type === 1 ? per.type === 2 : per.type === 1)
            })
            .map(per => {
              return {
                due: this.getDue(per) || {},
                ...per
              }
            })
            .filter(per => {
              let now = moment().format('YYYY-MM-DD'),
                  due = per.due || {}
              return moment(due.date).isSameOrBefore(now)
            })
            .sort((a, b) => new Date(a.due.date) - new Date(b.due.date))

      return data
    }
  }
}
</script>

<style src="@/components/financial/cashflow/styles/index.scss" lang="scss"></style>
<style lang="scss">
.mini-periodicals-table {
  #app & {
    .v-data-table__wrapper {
      border-radius: 7px;
      overflow: hidden;
      .v-data-table-header {
        background: #fcfcfc !important;
      }
    }
  }
}

.cashflow-table .mini-periodicals-row {
  #app & {
    cursor: pointer;
    background: #fffaf5 !important;
    &:hover {
      filter: brightness(101%) !important;
    }
    &.read {
      opacity: 0.74 !important;
    }
    .actions-col {
      min-width: 0px !important;
    }
  }
}
</style>
